import { COMPANY_PROFILE_TAB } from '@/components/misc/CompanyProfile/constants'
import { CompanyProfileTab } from '@/components/misc/CompanyProfile/types'
import { COMPANY_PROFILE_IDENTIFIER_TYPE } from '@/lib/constants'
import { CompanyProfileIdentifierType } from '@/types/misc'

class CompanyProfileService {
  isValidIdentifierType(
    identifierType: string,
  ): identifierType is CompanyProfileIdentifierType {
    return (
      identifierType === COMPANY_PROFILE_IDENTIFIER_TYPE.companyId ||
      identifierType === COMPANY_PROFILE_IDENTIFIER_TYPE.frn ||
      identifierType === COMPANY_PROFILE_IDENTIFIER_TYPE.sraNumber
    )
  }

  isValidTab(tab?: string | null): tab is CompanyProfileTab {
    return (
      !!tab && (Object.values(COMPANY_PROFILE_TAB) as string[]).includes(tab)
    )
  }
}

const companyProfileService = new CompanyProfileService()

export default companyProfileService
